<template>
  <SogFlexRow>
    <EvbActivationComponent
      :person="_selectedPerson"
      :address="_selectedAddress"
      :show-save-address="_selectedFromList"
      cancel-button-text="nicht generieren"
      @click-cancel="onCancel"
      @click-ok="onOk"
    />
    <SogCard v-show="_lst.length > 0 || _search.length > 0">
      <SogCardTitle>
        Wählen Sie einen Kontakt aus
      </SogCardTitle>
      <SogCardActions :is-toolbar="true">
        <sog-flex-row style="justify-content: flex-start">
          <SogTextBox
            v-model="_search"
            placeholder="Name"
          />
          <SogCardActionButton
            mdi-icon="mdi-magnify"
            style="align-self: flex-end"
            @click="onSearch"
          />
        </sog-flex-row>
      </SogCardActions>
      <SogCardContent>
        <SogFlexRow>
          <PersonAddressCardComponent
            v-for="item in _lst"
            :key="item"
            :person="item.Person"
            :address="item.Address"
            :allow-select="true"
            @click="onSelect(item)"
          />
        </SogFlexRow>
      </SogCardContent>
    </SogCard>
  </SogFlexRow>
</template>

<script setup lang="ts">

import EvbActivationComponent from "@/modules/Insurance/components/EvbActivationComponent.vue";
import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import copyTo, {replaceWith} from "@/shared/utils/CopyTo";
import {storeToRefs} from "pinia";
import {useRouter} from "vue-router";
import {onMounted, reactive, ref, watch} from "vue";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import getGuid from "@/shared/utils/getGuid";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import PersonAddressCardComponent from "@/modules/OrganisationStructure/components/PersonAddressCardComponent.vue";
import {useAccountStore} from "@/stores/accountStore";

const _shoppingCartStore = useShoppingCartStore();
const {currentShoppingCart} = storeToRefs(_shoppingCartStore)
const _accountStore = useAccountStore()

const _router = useRouter()

const _lst = reactive<{ Person: Person; Address: Address }[]>([])
const _selectedPerson = reactive<Person>(new Person())
const _selectedAddress = reactive<Address>(new Address())
const _selectedFromList = ref(false)
const _search = ref("")
const _key = ref("")
const _interval = ref<number | undefined>(undefined)


async function p_loadAddresses(filter?: string) {
  const lst = await apiOrganisationStructure.listAddress(_accountStore.person?.id ?? "", "activation", filter)
  _lst.length = 0
  if (lst) {
    _lst.push(...lst)
  }
}

onMounted(async () => {
  await p_loadAddresses()
})

watch(_search, () => {
  if (_interval.value) {
    clearInterval(_interval.value)
  }
  _key.value = getGuid();
  if (_search.value.length > 0 && _search.value.length < 3)
    return
  _interval.value = setInterval(async (key: string) => {
    if (_interval.value) {
      clearInterval(_interval.value)
    }
    const lst = await apiOrganisationStructure.listAddress(_accountStore.person?.id ?? "", "activation", _search.value)
    if (key !== _key.value)
      return;
    _lst.length = 0
    if (lst) {
      _lst.push(...lst)
    }
  }, 1000, _key.value)
})

async function onSearch() {
  if (_interval.value) {
    clearInterval(_interval.value)
  }
  await p_loadAddresses(_search.value)
}

function onSelect(item: { Person: Person; Address: Address }) {
  replaceWith(item.Person, _selectedPerson)
  replaceWith(item.Address, _selectedAddress)
  _selectedFromList.value = true
}

function onCancel() {
  _router?.back()
}

function onOk(value: { activationDuration: number, person: Person, address: Address, saveAddress: boolean }) {
  currentShoppingCart.value.activation = true;
  currentShoppingCart.value.activationDuration = value.activationDuration;
  copyTo(value.person, currentShoppingCart.value.activationPerson.Person)
  copyTo(value.address, currentShoppingCart.value.activationPerson.Address)
  currentShoppingCart.value.saveActivationPerson = !_selectedFromList.value && value.saveAddress;
  _shoppingCartStore.navigate("cashpoint")
}

</script>

<style scoped>

</style>
